import React from "react";
import { EMPTY_STRING } from "../../../constants";

const IconButton = ({
  icon,
  disabled,
  handleClick,
  width,
  height,
  className = EMPTY_STRING,
}) => {
  return (
    <button
      type="button"
      disabled={disabled}
      className={`custom-icon-button ${
        disabled ? EMPTY_STRING : "cursor-pointer"
      } ${className}`}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled && handleClick) {
          handleClick();
        }
      }}
      style={{
        opacity: disabled ? 0.5 : 1,
        width: width,
        height: height ?? "auto",
      }}
    >
      {icon}
    </button>
  );
};

export default IconButton;
